// This file is auto-generated by @hey-api/openapi-ts
export var AdminTransferType;
(function (AdminTransferType) {
    AdminTransferType["CREDIT"] = "credit";
    AdminTransferType["DEBIT"] = "debit";
})(AdminTransferType || (AdminTransferType = {}));
/**
 * Approval state for a reviewable object:
 * * `pending`: approval is required and has not yet been resolved.
 * * `completed`: approval was required and has been resolved.
 * * `not_required`: this object never required approval.
 */
export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["PENDING"] = "pending";
    ApprovalStatus["COMPLETED"] = "completed";
    ApprovalStatus["NOT_REQUIRED"] = "not_required";
})(ApprovalStatus || (ApprovalStatus = {}));
/**
 * Authentication factor type
 */
export var AuthFactorType;
(function (AuthFactorType) {
    AuthFactorType["SMS"] = "sms";
    AuthFactorType["TOTP"] = "totp";
    AuthFactorType["WEBAUTHN"] = "webauthn";
})(AuthFactorType || (AuthFactorType = {}));
/**
 * The account condition that should have caused the authorization to be declined.
 */
export var CardDisputeAccountStatus;
(function (CardDisputeAccountStatus) {
    CardDisputeAccountStatus["ACCOUNT_CLOSED"] = "account_closed";
    CardDisputeAccountStatus["CREDIT_PROBLEM"] = "credit_problem";
    CardDisputeAccountStatus["FRAUD"] = "fraud";
})(CardDisputeAccountStatus || (CardDisputeAccountStatus = {}));
/**
 * How a dispute is resolved when the platform closes it in the cardholder's favor or the cardholder withdraws the claim.
 */
export var CardDisputeCloseResolution;
(function (CardDisputeCloseResolution) {
    CardDisputeCloseResolution["ACCEPT_CARDHOLDER_CLAIM"] = "accept_cardholder_claim";
    CardDisputeCloseResolution["CARDHOLDER_WITHDREW"] = "cardholder_withdrew";
})(CardDisputeCloseResolution || (CardDisputeCloseResolution = {}));
/**
 * What was wrong with the transaction currency: processed in a different currency than agreed, or converted with dynamic currency conversion the cardholder did not agree to.
 */
export var CardDisputeCurrencyError;
(function (CardDisputeCurrencyError) {
    CardDisputeCurrencyError["CURRENCY_DIFFERENCE"] = "currency_difference";
    CardDisputeCurrencyError["DYNAMIC_CURRENCY_CONVERSION"] = "dynamic_currency_conversion";
})(CardDisputeCurrencyError || (CardDisputeCurrencyError = {}));
export var CardDisputeEligibilityReason;
(function (CardDisputeEligibilityReason) {
    CardDisputeEligibilityReason["TRANSACTION_NOT_FOUND"] = "transaction_not_found";
    CardDisputeEligibilityReason["TRANSACTION_NOT_SETTLED"] = "transaction_not_settled";
    CardDisputeEligibilityReason["CURRENCY_MISMATCH"] = "currency_mismatch";
    CardDisputeEligibilityReason["AMOUNT_EXCEEDS_SETTLED_AMOUNT"] = "amount_exceeds_settled_amount";
    CardDisputeEligibilityReason["AMOUNT_EXCEEDS_RECEIPT_DIFFERENCE"] = "amount_exceeds_receipt_difference";
    CardDisputeEligibilityReason["AMOUNT_NOT_PARTIAL"] = "amount_not_partial";
    CardDisputeEligibilityReason["ACTIVE_DISPUTE_EXISTS"] = "active_dispute_exists";
    CardDisputeEligibilityReason["EXCEEDED_FILING_WINDOW"] = "exceeded_filing_window";
    CardDisputeEligibilityReason["MISSING_REQUIRED_EVIDENCE"] = "missing_required_evidence";
    CardDisputeEligibilityReason["REASON_NOT_APPLICABLE_TO_TRANSACTION"] = "reason_not_applicable_to_transaction";
})(CardDisputeEligibilityReason || (CardDisputeEligibilityReason = {}));
/**
 * Network-agnostic classification for dispute document evidence.
 */
export var CardDisputeEvidenceType;
(function (CardDisputeEvidenceType) {
    CardDisputeEvidenceType["CARDHOLDER_LETTER"] = "cardholder_letter";
    CardDisputeEvidenceType["MERCHANT_LETTER"] = "merchant_letter";
    CardDisputeEvidenceType["SALES_DRAFT"] = "sales_draft";
    CardDisputeEvidenceType["TE_FOLIO"] = "te_folio";
    CardDisputeEvidenceType["CREDIT_VOUCHER"] = "credit_voucher";
    CardDisputeEvidenceType["SHIPPING_RECEIPT"] = "shipping_receipt";
    CardDisputeEvidenceType["PROOF_OF_DELIVERY"] = "proof_of_delivery";
    CardDisputeEvidenceType["BANK_STATEMENT"] = "bank_statement";
    CardDisputeEvidenceType["CANCELLED_CHECK"] = "cancelled_check";
    CardDisputeEvidenceType["SECOND_OPINION"] = "second_opinion";
    CardDisputeEvidenceType["FULFILLMENT"] = "fulfillment";
    CardDisputeEvidenceType["AUTHORIZATION_RECORD"] = "authorization_record";
    CardDisputeEvidenceType["NETWORK_DOCUMENT"] = "network_document";
    CardDisputeEvidenceType["UPDATED_CARDHOLDER_LETTER"] = "updated_cardholder_letter";
    CardDisputeEvidenceType["UPDATED_MERCHANT_LETTER"] = "updated_merchant_letter";
    CardDisputeEvidenceType["AFFIDAVIT_OF_FRAUD"] = "affidavit_of_fraud";
    CardDisputeEvidenceType["OTHER"] = "other";
    CardDisputeEvidenceType["NETWORK_EXHIBIT"] = "network_exhibit";
    CardDisputeEvidenceType["ISSUER_CERTIFICATION"] = "issuer_certification";
    CardDisputeEvidenceType["TRANSACTION_RECEIPT"] = "transaction_receipt";
})(CardDisputeEvidenceType || (CardDisputeEvidenceType = {}));
/**
 * Whether a dispute concerns merchandise or services.
 */
export var CardDisputeMerchandiseOrServices;
(function (CardDisputeMerchandiseOrServices) {
    CardDisputeMerchandiseOrServices["MERCHANDISE"] = "merchandise";
    CardDisputeMerchandiseOrServices["SERVICES"] = "services";
})(CardDisputeMerchandiseOrServices || (CardDisputeMerchandiseOrServices = {}));
/**
 * A channel through which the cardholder contacted the merchant.
 */
export var CardDisputeMerchantContactMethod;
(function (CardDisputeMerchantContactMethod) {
    CardDisputeMerchantContactMethod["EMAIL"] = "email";
    CardDisputeMerchantContactMethod["CALL_CENTER"] = "call_center";
    CardDisputeMerchantContactMethod["MAIL"] = "mail";
    CardDisputeMerchantContactMethod["SMS"] = "sms";
    CardDisputeMerchantContactMethod["IN_PERSON"] = "in_person";
    CardDisputeMerchantContactMethod["WEBFORM"] = "webform";
})(CardDisputeMerchantContactMethod || (CardDisputeMerchantContactMethod = {}));
export var CardDisputeNextAction;
(function (CardDisputeNextAction) {
    CardDisputeNextAction["SUBMIT"] = "submit";
    CardDisputeNextAction["ADD_EVIDENCE"] = "add_evidence";
    CardDisputeNextAction["AWAIT_NETWORK_SUBMISSION"] = "await_network_submission";
    CardDisputeNextAction["AWAIT_NETWORK_RESPONSE"] = "await_network_response";
    CardDisputeNextAction["AWAIT_MANUAL_ARBITRATION"] = "await_manual_arbitration";
    CardDisputeNextAction["RESOLVE_REQUIRED_ACTION"] = "resolve_required_action";
    CardDisputeNextAction["RESPOND_TO_PREARBITRATION"] = "respond_to_prearbitration";
    CardDisputeNextAction["RESPOND_TO_MERCHANT_RESPONSE"] = "respond_to_merchant_response";
})(CardDisputeNextAction || (CardDisputeNextAction = {}));
/**
 * Why an original credit was not accepted.
 */
export var CardDisputeOriginalCreditNotAcceptedReason;
(function (CardDisputeOriginalCreditNotAcceptedReason) {
    CardDisputeOriginalCreditNotAcceptedReason["RECIPIENT_REFUSED"] = "recipient_refused";
    CardDisputeOriginalCreditNotAcceptedReason["PROHIBITED_BY_LOCAL_LAW"] = "prohibited_by_local_law";
})(CardDisputeOriginalCreditNotAcceptedReason || (CardDisputeOriginalCreditNotAcceptedReason = {}));
/**
 * The proof that the merchant was paid by other means: the other transaction's acquirer reference number or Visa transaction identifier when it was paid with another issuer's Visa card, or a cash receipt, cancelled check, third-party voucher, statement from the other card, or other document.
 */
export var CardDisputeOtherPaymentProof;
(function (CardDisputeOtherPaymentProof) {
    CardDisputeOtherPaymentProof["ACQUIRER_REFERENCE_NUMBER"] = "acquirer_reference_number";
    CardDisputeOtherPaymentProof["NETWORK_TRANSACTION_ID"] = "network_transaction_id";
    CardDisputeOtherPaymentProof["CASH_RECEIPT"] = "cash_receipt";
    CardDisputeOtherPaymentProof["CANCELLED_CHECK"] = "cancelled_check";
    CardDisputeOtherPaymentProof["THIRD_PARTY_VOUCHER"] = "third_party_voucher";
    CardDisputeOtherPaymentProof["OTHER_CARD_STATEMENT"] = "other_card_statement";
    CardDisputeOtherPaymentProof["OTHER"] = "other";
})(CardDisputeOtherPaymentProof || (CardDisputeOtherPaymentProof = {}));
/**
 * The reason for a card dispute, which selects the Visa dispute condition Column files: `fraud` (10), `no_authorization` (11), `incorrect_transaction_code` (12.2), `incorrect_currency` (12.3), `incorrect_account_number` (12.4), `incorrect_amount` (12.5), `duplicate_processing` (12.6.1), `paid_by_other_means` (12.6.2), `invalid_data` (12.7), `merchandise_services_not_received` (13.1), `canceled_recurring_transaction` (13.2), `not_as_described` (13.3), `damaged_or_defective_merchandise` (13.3), `quality_of_merchandise_or_services` (13.3), `terms_of_contract` (13.3, Visa Commercial Card Virtual Account transactions), `counterfeit_merchandise` (13.4), `misrepresentation` (13.5), `credit_not_processed` (13.6), `canceled_merchandise_or_services` (13.7), `original_credit_not_accepted` (13.8) and `non_receipt_cash_at_atm` (13.9). `other` has no Visa dispute condition and is not filed with the network.
 */
export var CardDisputeReason;
(function (CardDisputeReason) {
    CardDisputeReason["FRAUD"] = "fraud";
    CardDisputeReason["NO_AUTHORIZATION"] = "no_authorization";
    CardDisputeReason["INCORRECT_AMOUNT"] = "incorrect_amount";
    CardDisputeReason["INCORRECT_ACCOUNT_NUMBER"] = "incorrect_account_number";
    CardDisputeReason["MERCHANDISE_SERVICES_NOT_RECEIVED"] = "merchandise_services_not_received";
    CardDisputeReason["CANCELED_RECURRING_TRANSACTION"] = "canceled_recurring_transaction";
    CardDisputeReason["NOT_AS_DESCRIBED"] = "not_as_described";
    CardDisputeReason["COUNTERFEIT_MERCHANDISE"] = "counterfeit_merchandise";
    CardDisputeReason["MISREPRESENTATION"] = "misrepresentation";
    CardDisputeReason["CREDIT_NOT_PROCESSED"] = "credit_not_processed";
    CardDisputeReason["NON_RECEIPT_CASH_AT_ATM"] = "non_receipt_cash_at_atm";
    CardDisputeReason["OTHER"] = "other";
    CardDisputeReason["DUPLICATE_PROCESSING"] = "duplicate_processing";
    CardDisputeReason["PAID_BY_OTHER_MEANS"] = "paid_by_other_means";
    CardDisputeReason["INCORRECT_CURRENCY"] = "incorrect_currency";
    CardDisputeReason["INCORRECT_TRANSACTION_CODE"] = "incorrect_transaction_code";
    CardDisputeReason["INVALID_DATA"] = "invalid_data";
    CardDisputeReason["CANCELED_MERCHANDISE_OR_SERVICES"] = "canceled_merchandise_or_services";
    CardDisputeReason["DAMAGED_OR_DEFECTIVE_MERCHANDISE"] = "damaged_or_defective_merchandise";
    CardDisputeReason["QUALITY_OF_MERCHANDISE_OR_SERVICES"] = "quality_of_merchandise_or_services";
    CardDisputeReason["ORIGINAL_CREDIT_NOT_ACCEPTED"] = "original_credit_not_accepted";
    CardDisputeReason["TERMS_OF_CONTRACT"] = "terms_of_contract";
})(CardDisputeReason || (CardDisputeReason = {}));
/**
 * What the cardholder certifies about a canceled guaranteed reservation: `properly_canceled` (the cardholder properly canceled the guaranteed reservation), `attempted_cancellation_within_24_hours` (the cardholder attempted to cancel within 24 hours of delivery of the reservation confirmation) or `no_show_billed_for_more_than_one_day` (the merchant billed a no-show transaction for more than one day's accommodation or rental).
 */
export var CardDisputeReservationCertification;
(function (CardDisputeReservationCertification) {
    CardDisputeReservationCertification["PROPERLY_CANCELED"] = "properly_canceled";
    CardDisputeReservationCertification["ATTEMPTED_CANCELLATION_WITHIN_24_HOURS"] = "attempted_cancellation_within_24_hours";
    CardDisputeReservationCertification["NO_SHOW_BILLED_FOR_MORE_THAN_ONE_DAY"] = "no_show_billed_for_more_than_one_day";
})(CardDisputeReservationCertification || (CardDisputeReservationCertification = {}));
/**
 * A response action the platform can take against a dispute stage via POST /respond. Cardholder withdrawal is not a response action; it routes through POST /close.
 */
export var CardDisputeResponseAction;
(function (CardDisputeResponseAction) {
    CardDisputeResponseAction["ACCEPT"] = "accept";
    CardDisputeResponseAction["ACCEPT_PARTIAL"] = "accept_partial";
    CardDisputeResponseAction["DECLINE"] = "decline";
    CardDisputeResponseAction["ESCALATE"] = "escalate";
})(CardDisputeResponseAction || (CardDisputeResponseAction = {}));
/**
 * How the cardholder returned merchandise to the merchant.
 */
export var CardDisputeReturnMethod;
(function (CardDisputeReturnMethod) {
    CardDisputeReturnMethod["FACE_TO_FACE"] = "face_to_face";
    CardDisputeReturnMethod["FEDEX"] = "fedex";
    CardDisputeReturnMethod["DHL"] = "dhl";
    CardDisputeReturnMethod["UPS"] = "ups";
    CardDisputeReturnMethod["POSTAL_SERVICE"] = "postal_service";
    CardDisputeReturnMethod["OTHER"] = "other";
})(CardDisputeReturnMethod || (CardDisputeReturnMethod = {}));
/**
 * Why the merchant did not provide or accept a merchandise return.
 */
export var CardDisputeReturnRefusalReason;
(function (CardDisputeReturnRefusalReason) {
    CardDisputeReturnRefusalReason["REFUSED_RETURN_AUTHORIZATION"] = "refused_return_authorization";
    CardDisputeReturnRefusalReason["REFUSED_ACCEPT_RETURNED_MERCHANDISE"] = "refused_accept_returned_merchandise";
    CardDisputeReturnRefusalReason["ADVISED_NOT_TO_RETURN"] = "advised_not_to_return";
    CardDisputeReturnRefusalReason["NO_LONGER_EXISTS_OR_NOT_RESPONDING"] = "no_longer_exists_or_not_responding";
    CardDisputeReturnRefusalReason["DID_NOT_PROVIDE_CLEAR_RETURN_INSTRUCTIONS"] = "did_not_provide_clear_return_instructions";
})(CardDisputeReturnRefusalReason || (CardDisputeReturnRefusalReason = {}));
/**
 * The type of service a canceled-merchandise-or-services dispute concerns.
 */
export var CardDisputeServiceType;
(function (CardDisputeServiceType) {
    CardDisputeServiceType["TIMESHARE"] = "timeshare";
    CardDisputeServiceType["GUARANTEED_RESERVATION"] = "guaranteed_reservation";
    CardDisputeServiceType["OTHER"] = "other";
})(CardDisputeServiceType || (CardDisputeServiceType = {}));
export var CardDisputeStatus;
(function (CardDisputeStatus) {
    CardDisputeStatus["OPEN"] = "open";
    CardDisputeStatus["REQUIRES_ACTION"] = "requires_action";
    CardDisputeStatus["MANUAL_REVIEW_REQUIRED"] = "manual_review_required";
    CardDisputeStatus["CLOSED"] = "closed";
})(CardDisputeStatus || (CardDisputeStatus = {}));
/**
 * How the transaction code was incorrect. Only `credit_instead_of_reversal` can be filed: Visa requires `credit_posted_as_debit` and `debit_posted_as_credit` disputes to claim twice the transaction amount, more than a dispute can claim, so they are rejected.
 */
export var CardDisputeTransactionCodeError;
(function (CardDisputeTransactionCodeError) {
    CardDisputeTransactionCodeError["CREDIT_INSTEAD_OF_REVERSAL"] = "credit_instead_of_reversal";
    CardDisputeTransactionCodeError["CREDIT_POSTED_AS_DEBIT"] = "credit_posted_as_debit";
    CardDisputeTransactionCodeError["DEBIT_POSTED_AS_CREDIT"] = "debit_posted_as_credit";
})(CardDisputeTransactionCodeError || (CardDisputeTransactionCodeError = {}));
/**
 * The Visa dispute workflow a dispute follows, selected by its dispute reason. Collaboration disputes negotiate through chargeback, representment, and pre-arbitration; allocation disputes cover fraud-related claims the acquirer responds to directly.
 */
export var CardDisputeWorkflow;
(function (CardDisputeWorkflow) {
    CardDisputeWorkflow["COLLABORATION"] = "collaboration";
    CardDisputeWorkflow["ALLOCATION"] = "allocation";
})(CardDisputeWorkflow || (CardDisputeWorkflow = {}));
export var CustomRoleGranularPermissionLevel;
(function (CustomRoleGranularPermissionLevel) {
    CustomRoleGranularPermissionLevel["DEFAULT"] = "default";
    CustomRoleGranularPermissionLevel["NONE"] = "none";
    CustomRoleGranularPermissionLevel["READ"] = "read";
    CustomRoleGranularPermissionLevel["UPDATE"] = "update";
    CustomRoleGranularPermissionLevel["WRITE"] = "write";
})(CustomRoleGranularPermissionLevel || (CustomRoleGranularPermissionLevel = {}));
export var CustomRolePermissionLevel;
(function (CustomRolePermissionLevel) {
    CustomRolePermissionLevel["DEFAULT"] = "default";
    CustomRolePermissionLevel["NONE"] = "none";
    CustomRolePermissionLevel["READ"] = "read";
    CustomRolePermissionLevel["WRITE"] = "write";
})(CustomRolePermissionLevel || (CustomRolePermissionLevel = {}));
/**
 * Dashboard display mode
 */
export var DashboardDisplayMode;
(function (DashboardDisplayMode) {
    DashboardDisplayMode["LIGHT"] = "light";
    DashboardDisplayMode["DARK"] = "dark";
})(DashboardDisplayMode || (DashboardDisplayMode = {}));
/**
 * Email verification state
 */
export var EmailState;
(function (EmailState) {
    EmailState["EMAILSTATE_NONE"] = "EMAILSTATE_NONE";
    EmailState["NOT_VERIFIED"] = "NOT_VERIFIED";
    EmailState["VERIFY_IN_PROGRESS"] = "VERIFY_IN_PROGRESS";
    EmailState["VERIFIED"] = "VERIFIED";
})(EmailState || (EmailState = {}));
/**
 * Login challenge name
 */
export var LoginChallengeName;
(function (LoginChallengeName) {
    LoginChallengeName["CHALLENGE_NONE"] = "CHALLENGE_NONE";
    LoginChallengeName["CHALLENGE_MFA_SMS"] = "CHALLENGE_MFA_SMS";
    LoginChallengeName["CHALLENGE_MFA_TOTP"] = "CHALLENGE_MFA_TOTP";
})(LoginChallengeName || (LoginChallengeName = {}));
/**
 * Email confirmation status
 */
export var LoginEmailConfirmationStatus;
(function (LoginEmailConfirmationStatus) {
    LoginEmailConfirmationStatus["NONE"] = "NONE";
    LoginEmailConfirmationStatus["UNVERIFIED"] = "UNVERIFIED";
    LoginEmailConfirmationStatus["VERIFIED"] = "VERIFIED";
    LoginEmailConfirmationStatus["NOT_REQUIRED"] = "NOT_REQUIRED";
})(LoginEmailConfirmationStatus || (LoginEmailConfirmationStatus = {}));
/**
 * MFA status
 */
export var LoginMfaStatus;
(function (LoginMfaStatus) {
    LoginMfaStatus["NONE"] = "NONE";
    LoginMfaStatus["UNVERIFIED"] = "UNVERIFIED";
    LoginMfaStatus["VERIFIED"] = "VERIFIED";
    LoginMfaStatus["NOT_REQUIRED"] = "NOT_REQUIRED";
    LoginMfaStatus["VERIFIED_LEGACY"] = "VERIFIED_LEGACY";
})(LoginMfaStatus || (LoginMfaStatus = {}));
/**
 * Groups of related notifications.
 */
export var NotificationCategory;
(function (NotificationCategory) {
    NotificationCategory["TRANSFER_OUTGOING_PENDING_APPROVAL"] = "transfer.outgoing.pending_approval";
    NotificationCategory["TRANSFER_OUTGOING_INITIATED"] = "transfer.outgoing.initiated";
    NotificationCategory["TRANSFER_OUTGOING_COMPLETED"] = "transfer.outgoing.completed";
    NotificationCategory["TRANSFER_OUTGOING_RETURNED"] = "transfer.outgoing.returned";
    NotificationCategory["TRANSFER_INCOMING_RECEIVED"] = "transfer.incoming.received";
    NotificationCategory["TRANSFER_INCOMING_PENDING_RETURN"] = "transfer.incoming.pending_return";
    NotificationCategory["TRANSFER_INCOMING_RETURNED"] = "transfer.incoming.returned";
})(NotificationCategory || (NotificationCategory = {}));
/**
 * Delivery channel for a notification.
 */
export var NotificationType;
(function (NotificationType) {
    NotificationType["EMAIL"] = "email";
})(NotificationType || (NotificationType = {}));
/**
 * The status of a 3DS authentication attempt
 */
export var ThreeDsAttemptStatus;
(function (ThreeDsAttemptStatus) {
    ThreeDsAttemptStatus["REJECTED"] = "rejected";
    ThreeDsAttemptStatus["PRESENTED"] = "presented";
    ThreeDsAttemptStatus["CHALLENGED"] = "challenged";
    ThreeDsAttemptStatus["AUTHENTICATED"] = "authenticated";
    ThreeDsAttemptStatus["ASSOCIATED"] = "associated";
})(ThreeDsAttemptStatus || (ThreeDsAttemptStatus = {}));
/**
 * The type of challenge used in 3DS authentication
 */
export var ThreeDsChallengeType;
(function (ThreeDsChallengeType) {
    ThreeDsChallengeType["FRICTIONLESS"] = "frictionless";
    ThreeDsChallengeType["ATTEMPTS"] = "attempts";
    ThreeDsChallengeType["OTP"] = "otp";
    ThreeDsChallengeType["BIOMETRIC"] = "biometric";
    ThreeDsChallengeType["EXTERNAL"] = "external";
})(ThreeDsChallengeType || (ThreeDsChallengeType = {}));
/**
 * The reason for the 3DS authentication outcome
 */
export var ThreeDsOutcomeReason;
(function (ThreeDsOutcomeReason) {
    ThreeDsOutcomeReason["FRICTIONLESS"] = "frictionless";
    ThreeDsOutcomeReason["CHALLENGED_ACCEPTED"] = "challenged_accepted";
    ThreeDsOutcomeReason["ATTEMPTS"] = "attempts";
    ThreeDsOutcomeReason["CARD_ACCOUNT_STATUS"] = "card_account_status";
    ThreeDsOutcomeReason["FAILED_CHALLENGE"] = "failed_challenge";
    ThreeDsOutcomeReason["RULE_REJECTED"] = "rule_rejected";
    ThreeDsOutcomeReason["ERROR"] = "error";
})(ThreeDsOutcomeReason || (ThreeDsOutcomeReason = {}));
export var WireReturnRequestReason;
(function (WireReturnRequestReason) {
    WireReturnRequestReason["INCORRECT_BENEFICIARY_ACCOUNT"] = "incorrect_beneficiary_account";
    WireReturnRequestReason["INCORRECT_AMOUNT"] = "incorrect_amount";
    WireReturnRequestReason["REQUESTED_BY_ORIGINATOR"] = "requested_by_originator";
    WireReturnRequestReason["DUPLICATE"] = "duplicate";
    WireReturnRequestReason["FRAUD"] = "fraud";
    WireReturnRequestReason["TECH_FAILURE"] = "tech_failure";
    WireReturnRequestReason["PAYMENT_NOT_JUSTIFIED"] = "payment_not_justified";
})(WireReturnRequestReason || (WireReturnRequestReason = {}));
export var WireReturnRequestRejectReason;
(function (WireReturnRequestRejectReason) {
    WireReturnRequestRejectReason["BENEFICIARY_ACCOUNT_CLOSED"] = "beneficiary_account_closed";
    WireReturnRequestRejectReason["NON_SUFFICIENT_FUNDS"] = "non_sufficient_funds";
    WireReturnRequestRejectReason["FUNDS_ALREADY_RETURNED"] = "funds_already_returned";
    WireReturnRequestRejectReason["REJECTED_BY_BENEFICIARY"] = "rejected_by_beneficiary";
    WireReturnRequestRejectReason["LEGAL_DECISION"] = "legal_decision";
    WireReturnRequestRejectReason["NO_RESPONSE_FROM_BENEFICIARY"] = "no_response_from_beneficiary";
})(WireReturnRequestRejectReason || (WireReturnRequestRejectReason = {}));
//# sourceMappingURL=types.gen.js.map